export default (message) => {
    if (typeof capsidDebugMessage === "function") {
        capsidDebugMessage(message);
    }
};
